import React, { useState, useEffect } from "react";
import { registerDevice } from 'src/legacy/redux/actions/userDevices';
import { useDispatch, useSelector } from "react-redux";
import { intercom, smartlook } from '../../config.jsx';
import { fetchUserProfile } from '../../redux/actions/users';
import userRoleService from '../../utils/userRoles.service.js';
import subscriptionPlanService from 'src/utils/subscriptionPlan.service.js';
import { identifyUserForAdoption } from "src/redux/actions/adoption";
import SimilarContent from "../asset/similarContent/index";

import Intercom from 'react-intercom';
import smartlookClient from 'smartlook-client';
import { oneSignal } from '../../config.jsx';
import { GlobalToastManager } from "../globalToastManager"
import WebSocket from "../webSocket";

import _ from "lodash";

declare global {
  interface Window {
    OneSignal: any;
    webPushNotificationEnabled?: boolean;
    pendo: any;
  }
}

const AppServices: React.FC<any> = ({ children }) => {
  const dispatch = useDispatch();
  
  const users = useSelector((state: any) => _.get(state, "users.me", null));
  const account = useSelector((state: any) => _.get(state, "accounts.item", null));

  const identifyUserInSmartlook = (profile: any) => {
    if (!(smartlook && smartlook.projectKey)) {
      return false;
    }

    const name = `${_.get(profile, 'firstName', '')} ${_.get(profile, 'lastName', '')}`;
    const companyName = _.get(account, 'item.name', '');
    
    smartlookClient.identify(profile.email, {
      name: name,
      email: profile.email,
      Company: companyName,
      "Job Title": _.get(profile, 'title', '')
    });
  };

  const initiateWebPushNotification = () => {
    const OneSignal = window.OneSignal || [];
    OneSignal.push(() => {
      if (!window.webPushNotificationEnabled) {
        const options = {
          appId: oneSignal.appId,
          autoResubscribe: true,
          notifyButton: {
            enable: true
          },
          allowLocalhostAsSecureOrigin: true
        };

        if (oneSignal.subdomainName) {
          options['subdomainName'] = oneSignal.subdomainName;
        }

        OneSignal.init(options);
        window.webPushNotificationEnabled = true;
      }

      OneSignal.on('subscriptionChange', (isSubscribed) => {
        if (isSubscribed) {
          OneSignal.getUserId((userId) => {
            if (userId) {
              registerDevice(userId);
            }
          });
        }
      });

      OneSignal.getUserId((userId) => {
        if (userId) {
          registerDevice(userId);
        }
      });
    });
  };

  const initializeServices = () => {
    if (users && account) {
      userRoleService.initialise(users, account);
      subscriptionPlanService.initialise(account);

      if (window.pendo) {
        window.pendo.initialize({
          visitor: {
            id: users.id,
            firstName: users.firstName,
            lastName: users.lastName,
            email: users.email,
          },
          account: {
            id: account.id,
            name: account.name,
            subscription_type: account.subscription.type,
            no_of_days: account.subscription.noOfDays,
            show_trial_banner: account.trialBanner
          },
        });
      } 
    }
  };

  const initiateMixPanel = () => {
    dispatch(identifyUserForAdoption());
  }

  useEffect(() => {
    initiateWebPushNotification();
    initializeServices();
    initiateMixPanel();
  }, []);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (users) {
      identifyUserInSmartlook(users);
    }
  }, [users]);

  return (
    <>
      {users && account && (
        <Intercom
          key="intercom"
          appID={intercom.appID}
          user_id={users.email}
          email={users.email}
          name={`${users.firstName || ""} ${users.lastName || ""}`}
          company={{
            name: account.name,
            id: account.id,
            created_at: Math.floor(account.createdDate / 1000),
            plan: account.subscription ? account.subscription.type : 'TRIAL'
          }}
          custom_launcher_selector="#intercom_launcher"
          hide_default_launcher={true}
        />
      )}

      <WebSocket>{children}</WebSocket>
      
      <SimilarContent />
      <GlobalToastManager />
    </>
  );
};

export default AppServices;